export default "__VITE_ASSET__Eo38mUxN__"